module.exports = __webpack_public_path__ + "static/heroslide-10-32fca1b6dbac7c00e35874c3b8d8655a.jpeg";